import { render, staticRenderFns } from "./DrawerDetial.vue?vue&type=template&id=2b675f8e&scoped=true"
import script from "./DrawerDetial.vue?vue&type=script&lang=js"
export * from "./DrawerDetial.vue?vue&type=script&lang=js"
import style0 from "./DrawerDetial.vue?vue&type=style&index=0&id=2b675f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b675f8e",
  null
  
)

export default component.exports